/**
 * @desc - マウスオーバーで画像切替
 * @link - http://desire-designer.boo.jp/wp/?p=39
 */

$(function () {
  $('a img').hover(function () {
    $(this).attr('src', $(this).attr('src').replace('_off', '_on'));
  }, function () {
    if (!$(this).hasClass('currentPage')) {
      $(this).attr('src', $(this).attr('src').replace('_on', '_off'));
    }
  });
});